import React from 'react';

import {AlertActions, AlertModal} from 'presentation/components';
import {homeAddressUpdateModalByMode} from './constants';
import {AddressUpdateModalProps} from './types';

export function AddressUpdateModal({
	open,
	mode,
	onClose,
	onNavigateToAddressForm,
	onNavigateToAddressList,
	onNavigateToAddressFormWithCasa,
	subDescription,
	onConfirmConfirmation,
	onConfirmFirstAccess,
	onConfirmSuggestion,
	onRejectSuggestion,
	isPrimaryActionLoading,
	isSecondaryActionLoading,
	isActionsDisabled,
}: AddressUpdateModalProps) {
	const content = homeAddressUpdateModalByMode[mode];

	const handlePrimaryAction = () => {
		if (mode === 'confirmation') {
			onConfirmConfirmation?.();
			return;
		}

		if (mode === 'firstAccess') {
			onConfirmFirstAccess?.();
			return;
		}

		if (mode === 'suggestion') {
			onConfirmSuggestion?.();
			return;
		}

		if (mode === 'request') {
			onNavigateToAddressForm();
			return;
		}

		onNavigateToAddressList?.();
	};

	const handleSecondaryAction = () => {
		if (mode === 'confirmation') {
			onNavigateToAddressForm();
			return;
		}

		if (mode === 'firstAccess') {
			onNavigateToAddressFormWithCasa?.();
			return;
		}

		if (mode === 'suggestion') {
			onRejectSuggestion?.();
			return;
		}

		onClose();
	};

	return (
		<AlertModal
			headerTitle={content.headerTitle}
			title={content.title}
			description={content.description}
			subDescription={subDescription}
			variant={content.variant}
			preWrap={true}
			open={open}
			onClose={onClose}
			footerContent={
				<AlertActions
					primaryText={content.primaryAction}
					secondaryText={content.secondaryAction}
					primaryAction={handlePrimaryAction}
					secondaryAction={handleSecondaryAction}
					isLoading={isPrimaryActionLoading}
					isLoadingSecondary={isSecondaryActionLoading}
					isDisabled={isActionsDisabled}
					isDisabledSecondary={isActionsDisabled}
					flexDirection="column-reverse"
				/>
			}
		/>
	);
}
